<template>
  <LargeModal
    :show="show"
    title="Make an offer"
    subtitle="Submit an offer on the request"
    @close="$emit('close')"
  >
    <label
      for="amount"
      class="block text-sm font-medium text-gray-700"
    > Amount </label>
    <div class="relative mt-1 flex rounded-md shadow-sm">
      <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <span class="text-gray-500 sm:text-sm">
          {{ currency ? currency.symbol : '$' }}
        </span>
      </div>
      <input
        id="amount"
        v-model="form.amount"
        type="text"
        name="amount"
        placeholder="0.00"
        autocomplete="username"
        class="flex-1 pl-11 focus:ring-indigo-500 focus:border-indigo-500 block w-full min-w-0 rounded-none rounded-l-md sm:text-sm border-gray-300"
      >
      <span class="inline-flex items-center px-3 w-72 rounded-r-md border border-l-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
        <CurrencySelectPicker
          v-model="currency"
          label=""
          :borders="false"
          class="w-72 -mx-3 -mt-1"
        />
      </span>
    </div>

    <template #footer>
      <CreateButton
        class="m-2"
        @click="save"
      >
        Make offer
      </CreateButton>
      <CancelButton
        class="m-2"
        @click="close"
      />
    </template>
  </LargeModal>
</template>

<script>

import LargeModal from '@/ComponentsDeprecated/Modal/LargeModal';
import CancelButton from '@/ComponentsDeprecated/Buttons/CancelButton';
import CreateButton from '@/ComponentsDeprecated/Buttons/CreateButton';
import CurrencySelectPicker from '@/ComponentsDeprecated/Select/CurrencySelectPicker';

export default {
  components: {
    CurrencySelectPicker,
    LargeModal,
    CreateButton,
    CancelButton,
  },
  props: [
    'show',
    'request',
    'currencies',
  ],
  data() {
    return {
      currency: null,
      client_contact: [],
      form: this.$inertia.form({
        currency_id: null,
        amount: null,
      }),
    };
  },
  methods: {
    save() {
      this.form.currency_id = this.currency.id;
      this.form.post(route('engagements.requests.offer', { engagementRequest: this.request.id }), {
        errorBag: 'storeOffer',
        preserveScroll: true,
        onSuccess: () => {
          this.form.reset();
          this.$emit('close');
          this.$emit('offerGiven');
        },
      });
    },
    close() {
      this.$emit('close');
      this.form.reset();
    },

  },
};
</script>
